export default __webpack_public_path__ + "static/media/profileImg.d9f4801d.JPEG";